(function () {

    'use strict';

    angular
        .module('app.home')
        .controller('HomeController', [
            '$routeParams',
            'ApiService',
            'GaService',
            '$location',
            HomeController
        ]);

    function HomeController($routeParams, apiService, gaService, $location) {
        var vm = this;

        init();

        function init() {
            if (angular.isDefined($routeParams.locCode) && angular.isDefined($routeParams.langCode)) {
                gaService.gaTrackPageViewAsync($location.path().toString(), 'Home Page');
                apiService.getLocations($routeParams.langCode).then(function (response) {
                    var homeBannerUrls = [];
                   // var banners = apiService.getLocationByCode(response.data, $routeParams.locCode).banners;
                    var banner;
                    var bannerSrc;
                    
                    /*if($routeParams.locCode === 'richmond'){
                		bannerSrc='resource/image/locations/richmond/en/Richmond_Banner.png';
						 banner = {
                            src: bannerSrc,
							alt: 'Big and small image A',
                           link: ''
                        };
						homeBannerUrls.push(banner);
					}else{
                    
                    for (var i = 0; i < banners.length; i++) {
                        if (banners[i].bannerType === 'file' && !banners[i].commonBanner) {
                            bannerSrc = 'resource/image/locations/' + $routeParams.locCode + '/' + $routeParams.langCode + '/' + banners[i].src;
                        } else if (banners[i].bannerType === 'file' && banners[i].commonBanner) {
                            bannerSrc = 'resource/image/common/' + banners[i].src;
                        }  else {
                            bannerSrc = banners[i].src;
                        }
                        banner = {
                            src: bannerSrc,
                            alt: banners[i].slideName,
                            link: banners[i].link
                        };
                        homeBannerUrls.push(banner);
                  }*/
                    if ($routeParams.langCode == 'en'){
                    	var banners =['resource/image/common/CA-MKTG-1219-PUBLIC-SITE-WBNR-1-EN.jpg', 'resource/image/common/CA-MKTG-1219-PUBLIC-SITE-WBNR-2-EN.jpg','resource/image/common/CA-MKTG-1219-PUBLIC-SITE-WBNR-3-EN.jpg']
                    }else{
                    	var banners =['resource/image/common/CA-MKTG-1219-PUBLIC-SITE-WBNR-1-FR.jpg', 'resource/image/common/CA-MKTG-1219-PUBLIC-SITE-WBNR-2-FR.jpg','resource/image/common/CA-MKTG-1219-PUBLIC-SITE-WBNR-3-FR.jpg']
                    }
                    for (var i = 0; i < banners.length; i++) {
                    	 bannerSrc = banners[i];
                    	 banner = {
                                 src: bannerSrc,
                                 alt: 'Common Banner',
                                 link: ''
                             };
                         homeBannerUrls.push(banner);
                    }
                    
                   /* bannerSrc='resource/image/common/notice1.jpg';
                    banner = {
                            src: bannerSrc,
                            alt: 'Common Banner',
                            link: ''
                        };
                         homeBannerUrls.push(banner);*/
                    vm.homeBannerUrls = homeBannerUrls;
                });
            }
        }
    }

})();



// WEBPACK FOOTER //
// ./app/home/HomeController.js